import dayjs from "dayjs";
import { getDateTimeFormat, getIntlLocale, normalizeAppLanguage } from "util/locale";

export function formatAppDateTime(value, language, options = {}) {
  if (value == null || value === "") return "";
  const { format, useDayjs = true } = options;
  const lang = normalizeAppLanguage(language);
  const locale = getIntlLocale(lang);

  if (typeof value === "number" || (typeof value === "string" && /^\d+(\.\d+)?$/.test(value.trim()))) {
    const num = Number(value);
    if (Number.isFinite(num) && num >= 1e9 && num < 1e12) {
      const d = dayjs.unix(Math.floor(num));
      if (d.isValid() && d.year() >= 2000) {
        return useDayjs
          ? d.format(format || getDateTimeFormat(lang))
          : d.toDate().toLocaleString(locale);
      }
    }
  }

  if (useDayjs) {
    const d = dayjs(value);
    if (d.isValid() && d.year() >= 2000) {
      return d.format(format || getDateTimeFormat(lang));
    }
    return "";
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime()) || date.getFullYear() < 2000) return "";
  return date.toLocaleString(locale);
}

/** Date-only label (no time) using app locale. */
export function formatAppDate(value, language) {
  if (value == null || value === "") return "";
  const locale = getIntlLocale(normalizeAppLanguage(language));
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime()) || date.getFullYear() < 2000) return "";
  return date.toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
